import Dashboard from "../pages/dashboard";
import AccountProfile from "../pages/sellers/profile";
import AccountLogin from "../pages/accounts/login";
import AccountForgotPin from "../pages/accounts/forgot-pin";
import BuyerList from "../pages/buyers/list";
import BuyerProfile from "../pages/buyers/profile";
import SanitarywareList from "../pages/products/sanitaryware/list";
import SanitarywareDetail from "../pages/products/sanitaryware/detail";
import SanitarywareCreate from "../pages/products/sanitaryware/create";
import SanitarywareImages from "../pages/products/sanitaryware/images";
import SanitarywarePdfs from "../pages/products/sanitaryware/pdfs";
import SanitarywareAttributes from "../pages/products/sanitaryware/attributes";
import SanitarywareTypes from "../pages/products/sanitaryware/types";
import TilesList from "../pages/products/tiles/list";
import TilesDetail from "../pages/products/tiles/detail";
import TilesCreate from "../pages/products/tiles/create";
import TilesPdfs from "../pages/products/tiles/pdfs";
import AccountChangePin from "../pages/accounts/change-pin";
import SellerCatalogs from "../pages/sellers/catalogs";
import SellerReviews from "../pages/sellers/reviews";
import TileInquiryClickList from "../pages/sellers/tile-inquiry-click-list";
import SanitarywareInquiryClickList from "../pages/sellers/sanitaryware-inquiry-click-list";
import SocialPosts from "../pages/posts/index";
import SocialPostCreate from "../pages/posts/create";
import Subscription from "../pages/subscription/subscription";
import SubscriptionSuccess from "../pages/subscription/success";
import MySubscription from "../pages/subscription/my-subscription";
import TermsPrivacy from "../pages/legal/terms-privacy";
import Help from "../pages/legal/help";
import InvoicePage from "../pages/invoice";

const AdminRoutes = [
  { path: "", component: <Dashboard /> },
  { path: "dashboard", component: <Dashboard /> },
  { path: "accounts/login", component: <AccountLogin /> },
  { path: "accounts/forgot-pin", component: <AccountForgotPin /> },
  { path: "accounts/change-pin", component: <AccountChangePin /> },
  { path: "buyers", component: <BuyerList /> },
  { path: "buyers/profile", component: <BuyerProfile /> },
  { path: "buyers/profile/:id", component: <BuyerProfile /> },
  { path: "products/sanitaryware", component: <SanitarywareList /> },
  { path: "products/sanitaryware/create", component: <SanitarywareCreate /> },
  { path: "products/sanitaryware/:product_id", component: <SanitarywareDetail /> },
  { path: "products/sanitaryware/:product_id/edit", component: <SanitarywareCreate /> },
  { path: "products/sanitaryware/:product_id/images", component: <SanitarywareImages /> },
  { path: "products/sanitaryware/:product_id/pdfs", component: <SanitarywarePdfs /> },
  { path: "products/sanitaryware/attributes", component: <SanitarywareAttributes /> },
  { path: "products/sanitaryware/types", component: <SanitarywareTypes /> },
  { path: "products/tiles", component: <TilesList /> },
  { path: "products/tiles/create", component: <TilesCreate /> },
  { path: "products/tiles/:product_id", component: <TilesDetail /> },
  { path: "products/tiles/:product_id/edit", component: <TilesCreate /> },
  { path: "products/tiles/:product_id/pdfs", component: <TilesPdfs /> },
  { path: "sellers/profile", component: <AccountProfile /> },
  { path: "sellers/catalogs", component: <SellerCatalogs /> },
  { path: "sellers/reviews", component: <SellerReviews /> },
  { path: "sellers/tile-inquiry-click-list", component: <TileInquiryClickList /> },
  { path: "sellers/sanitaryware-inquiry-click-list", component: <SanitarywareInquiryClickList /> },
  { path: "social/posts", component: <SocialPosts /> },
  { path: "social/posts/create", component: <SocialPostCreate /> },
  { path: "subscription", component: <Subscription /> },
  { path: "subscription/success", component: <SubscriptionSuccess /> },
  { path: "subscription/my-subscription", component: <MySubscription /> },
  { path: "invoice", component: <InvoicePage /> },
  { path: "legal/terms-privacy", component: <TermsPrivacy /> },
  { path: "legal/help", component: <Help /> },
];

export default AdminRoutes;
